// extracted by mini-css-extract-plugin
module.exports = {"list":"_02712f2b3b--list--Lz2bw"};